import React, { useState, useEffect } from 'react';

import Container from 'components/Container';
import { BlockLoader } from 'components/Loaders';
import { NomenclatureGroupsCard } from 'components/Cards';
import { useStores } from 'hooks/useStores';

import style from './styles/main.module.scss';

const loadersCount = 14;

const NomenclatureGroups = () => {
  const [showAllNG, setShowAllNG] = useState(0); // 0 - количество по дефолту, 1 - показать все
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState();
  const { api } = useStores();

  useEffect(() => {
    setLoading(true);
    api.newCatalog
      .getNomenclatureGroups({
        all: showAllNG,
      })
      .then((res) => {
        setResponse(res);
      })
      .finally(() => setLoading(false));
  }, [showAllNG]);

  const loaders = Array.from({ length: loadersCount }, (_, index) => (
    <BlockLoader height={206} key={index} />
  ));

  const handleShowAllNG = () => {
    setShowAllNG(1);
  };

  return (
    <section className={style.ng}>
      <Container>
        <div className={style.ng__list}>
          {loading ? loaders : null}

          {!loading && response !== undefined ? (
            <>
              {
                // @ts-ignore
                response.results.map((group) => (
                  <NomenclatureGroupsCard key={group.id} group={group} />
                ))
              }

              {
                // @ts-ignore
                response.has_more === true ? (
                  <button
                    type="button"
                    onClick={handleShowAllNG}
                    className={style.ng__more}
                  >
                    <span>Все категории</span>
                    <span className={style.ng__more_icon} />
                  </button>
                ) : null
              }
            </>
          ) : null}
        </div>
      </Container>
    </section>
  );
};

export default NomenclatureGroups;
